<template>

  <div class="left" id='admin-left'>

    <!-- {{default_index}} -->

  <div>
    <img class='logo' src="../../static/img/logo1.png" >
  </div>
  <div class="user">
    <img :src="user.mainImg&&user.mainImg.length>0?user.mainImg[0]['url']:'../../static/img/home-img.png'" alt="" class="txImg">
    <div class="txt1">{{user&&user.info&&user.info.name}}</div>
    <div class="txt2">{{user.user_no}}</div>
    <div class="flex">
      <div class="btn" @click="updatePassword">修改密码</div>
      <div class="btn" @click="logout"><img src="../../static/img/home-icon5.png" alt="">退出登录</div>
    </div>
  </div>

  <el-menu

    :default-active="default_index"
    class="left_menu_class"
    @open="handleOpen"
    @close="handleClose"
    @select="handleSelect"
    background-color="#1C2B36"
    text-color="#869FB1"
    active-text-color="#fff"
    ref="testmenu"
    >

    <template v-for="(item,index) in menu" >
      <el-submenu v-if="item.children&&item.isShow" :index="item.id.toString()" :key="item.name">
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{item.name}}</span>
          <img src="../../static/img/home-icon29.png" alt="" class="menuBg" v-if="item.id==active_index">
          <div class="shadow"  v-if="item.id==active_index"></div>
        </template>

        <template v-for="(c_item,c_index) in item.children" >
          <el-submenu v-if="c_item.children&&c_item.isShow" :index="c_item.id.toString()" :key="c_item.name" @command="show">
            <template slot="title">
              <i :class="c_item.icon"></i>
              <span class="point" :class="default_index==c_item.id?'bg1':''"></span>
              <span class="line" v-if="c_index>0"></span>
              <span>{{c_item.name}}</span>
            </template>

            <template v-for="(cc_item,cc_index) in c_item.children" >
              <el-submenu v-if="cc_item.children&&cc_item.isShow" :index="cc_item.id.toString()" :key="cc_item.name">
                <i :class="cc_item.icon"></i>
                <span>{{cc_item.name}}</span>
              </el-submenu>
              <el-menu-item v-else-if="cc_item.isShow" :index="cc_item.id.toString()" :key="cc_item.name">
                <i :class="cc_item.icon"></i>
                <span slot="title">{{cc_item.name}}</span>
              </el-menu-item>
            </template>
          </el-submenu>

          <el-menu-item v-else-if="c_item.isShow" :index="c_item.id.toString()" :key="c_item.name">
            <!-- <i :class="c_item.icon"></i> -->
            <span class="point" :class="default_index==c_item.id?'bg1':''"></span>
            <span class="line" v-if="c_index>0"></span>
            <span slot="title"> {{c_item.name}}</span>
          </el-menu-item>
        </template>
      </el-submenu>
      <el-menu-item v-else-if="item.isShow" :index="item.id.toString()" :key="item.name">
        <i :class="item.icon"></i>
        <span slot="title">{{item.name}}</span>
        <img src="../../static/img/home-icon29.png" alt="" class="menuBg" v-if="index==active_index">
      </el-menu-item>
    </template>

  </el-menu>



      <div class="toggle-menu"
        @click='toggleMenu'
      >
        <i></i>
      </div>

  <!-- <div style="height: 72px;"></div>
  <div class="quit" @click="logout">
    <img src="../../static/img/home-icon5.png" alt="">
    <span>退出登录</span>
  </div> -->

  </div>
</template>

<script>
  import {gbs} from '../config/index.js';
  export default {
    name: 'left-menu',
    data () {
      return {
        menu_list: [],
        win_size: {
          height: ''
        },
        active_path:'',
        nbPath:'/adv/article/list',
        menu:[],
        default_index:'',
        active_index:'',
        user:{}

      }
    },
    created () {
      const self =this;



    },

    watch: {
      $route (to, from) {
        console.log('to.name',to.name)
        console.log('this.menu',this.menu)
        //this.init()
        var item = this.$$getArrayByTarget(this.menu,'name',to.name)[0];
        this.default_index = item['id'];
      },

    },

    mounted () {
      const self = this;
      self.menu = this.$store.state.user.menu;
      self.default_index = self.$store.state.tabs.tabs[0]['id'];
      self.active_index = self.$store.state.tabs.tabs[0]['parent'];
      console.log(self.default_index,self.active_index,'default_index');

      self.user = this.$store.getters.getUserinfo;

    },
    methods: {

      show(e){
        console.log('show',e)
      },

      tet(){
        this.default_index = '23';
      },
      handleSelect(index,indexPath){
        const self = this;

        self.default_index = index;
        self.active_index = index;
        var item = self.$$getArrayByTarget(self.menu,'id',index)[0];

        if(item.router){
          this.$router.push({ name: item.name, params: { delKeepAlive: true }})
          console.log('self.menu',item);
          self.active_index = item.parent;
          /* self.$router.push({
            path:item.router,
          }); */
        };
        //self.$refs.testmenu.open(index:'23');
      },

      updatePassword(){
        const self = this;
        this.$prompt('修改密码', '操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          self.updUserPass(value);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },

      /**
       * 修改密码
       * @param  {object} userinfo 当前修改密码的表单信息
       */
      async updUserPass (password) {
        const self = this;
        var postData={
          searchItem:{
            user_no:self.user.user_no
          },
          data:{
            password:password
          }
        };

        try{
          var res = await this.$$api_userUpdate({data: postData});
          this.$notify({
            title: '成功',
            message: '修改密码成功',
            type: 'success'
          });
        }catch(err){
          console.log(err);
          self.$message('网络故障');
        };
      },

      logout () {
        this.$confirm('你确定退出登录么?', '确认退出', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('remove_userinfo').then(() => {
            this.$router.push('/login')
          })
        })
      },


      handleOpen(index){

      },

      handleClose(){

      },

      initMenu(){
        const self = this;

      },

      checkInAuth(item){

        var index = this.$store.state.user.userinfo.auth.indexOf(item);
        if(index>=0){
          return true;
        }else{
          return false;
        };

      },
      setSize () {
        this.win_size.height = (this.$$lib_$(window).height() - 50) + 'px'
      },
      toggleMenu () {
        console.log(99635)
        this.active_path = this.$route.path;
        this.$store.dispatch(this.$store.state.leftmenu.menu_flag ? 'set_menu_close' : 'set_menu_open')
      },
      updateCurMenu (route) {
        const self = this;

        self.active_path = '';
        route = route||self.$route;
        if (route.matched.length) {
          var rootPath = route.matched[0].path;
          var fullPath = route.fullPath;
          self.$store.dispatch('set_cur_route', {
            rootPath,
            fullPath
          });
          var routes = self.$router.options.routes;
          for (var i = 0; i < routes.length; i++) {
            if (routes[i].path === rootPath && !routes[i].hidden) {
              self.menu_list = routes[i];
            };
          };
          this.active_path = this.$route.fullPath;
          this.nb_array = [route.matched[1].path];
        } else {
          self.$router.push('/404');
        };
      }

    },






  }

</script>
<style>

  .left{
    width: 100%;
    height: 100%;
    text-align:left;
    background-color: #1C2B36!important;
    overflow: auto;
    /* position: relative; */
  }

  .left_menu_class{
    border: none
  }

  .el-submenu__title{position: relative;}

  .el-submenu .el-menu .el-menu-item{border-right: 3px solid #0FA4E8;position: relative;}
  .left .el-submenu .el-menu-item{background-color: #131E26!important;}

  .left .point{width: 10px;height: 10px;background-color: #869FB1;border-radius: 50%;display: inline-block;margin-right: 5px;}
  .left .line{width: 1px;height: 50px;background-color: #869FB1;position: absolute;display: inline-block;left: 44px;top: -22px;}

  .user .flex{display: flex;align-items: center;justify-content: center;}
  .logo{margin-top: 15%;margin-LEFT: 20%;}
  .user{padding: 15% 0;display: flex;align-items: center;justify-content: center;color: #869FB1;flex-direction: column;line-height: 1.5;}
  .user .txImg{width: 80px;border-radius: 50%;margin-top: 30px;}
  .user .txt1{font-size: 16px;padding-top: 10px;}
  .user .txt2{font-size: 12px;padding-bottom: 5px;}
  .user .btn{width: 90px;height: 26px;line-height: 26px;background-color: #243847;border-radius: 5px;text-align: center;display: flex;align-items: center;justify-content: center;margin: 0 5px;font-size: 12px;}
  .user .btn img{width: 20px;margin-right: 5px;}

  .menuBg{height: 100%;width: auto;position: absolute;left: 0;top: 0;}

  .quit{width: 100%;height: 72px;color: #fff;position: absolute;bottom: 0;font-size: 14px;display: flex;align-items: center;background-color: #1C2B36;cursor: pointer;padding-left: 25px;box-sizing: border-box;}
  .quit img{margin-right: 10px;}

  .shadow{box-shadow: 0px 4px 9px -2px rgba(0, 0, 0, 0.3);position: absolute;width: 100%;height: 100%;top: 0;left: 0;z-index: 10;}

  .bg1{background-color: #fff!important;z-index: 10;position: relative;}

</style>

<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/layout/leftNav.vue